import React, { useMemo } from 'react'

import moment from 'moment'
import PropTypes from 'prop-types'

import { formatDateExibition } from '~/helpers'

const ColumnPicking = ({ data }) => {
  const shipment = useMemo(() => data.shipments?.[0], [data])
  const scheduleDateStr = data.schedule_datetime || data.schedule_date
  const slot = shipment?.schedule_time || shipment?.slot

  if (!scheduleDateStr || !slot) return null

  const base = moment.utc(scheduleDateStr)

  const [startStr, endStr] = slot.split(' - ')
  const [startHour, startMinute] = startStr.split(':')
  const [endHour, endMinute] = endStr ? endStr.split(':') : []

  const start = base
    .clone()
    .set({ hour: startHour, minute: startMinute, second: 0 })
  let end =
    endHour && endMinute
      ? base.clone().set({ hour: endHour, minute: endMinute, second: 0 })
      : null

  // Business rule - Picking must be made 2 hours before delivery slot
  const pickingStart = start.clone().subtract(2, 'hours')
  const pickingEnd = end ? end.clone().subtract(2, 'hours') : null

  const pickingSlot = `${pickingStart.format('HH:mm')}${
    pickingEnd ? ` - ${pickingEnd.format('HH:mm')}` : ''
  }`

  return (
    <div>
      {formatDateExibition(pickingStart.toDate())}
      <br />
      <small>{pickingSlot}</small>
    </div>
  )
}

ColumnPicking.propTypes = {
  data: PropTypes.shape({
    shipments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    schedule_date: PropTypes.string.isRequired
  }).isRequired
}

export default ColumnPicking
